(function () {
  const storage = window.selinzaSafeStorage;
  const storageKey = "shopify-wishlist";
  const delimiter = ",";
  const activeClass = "active";

  function getWishlist() {
    const wishlist = storage?.getItem(storageKey);
    if (!wishlist) return [];

    return wishlist
      .split(delimiter)
      .map((handle) => handle.trim())
      .filter(Boolean);
  }

  function setWishlist(array) {
    const uniqueWishlist = Array.from(new Set(array.filter(Boolean)));
    const wishlist = uniqueWishlist.join(delimiter);

    if (uniqueWishlist.length) storage?.setItem(storageKey, wishlist);
    else storage?.removeItem(storageKey);

    return uniqueWishlist;
  }

  function updateWishlist(handle) {
    const wishlist = getWishlist();
    const indexInWishlist = wishlist.indexOf(handle);

    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);

    return setWishlist(wishlist);
  }

  function updateWishlistCounter() {
    const wishlistItemLength = getWishlist().length;
    document.querySelectorAll(".wishlist__count").forEach((counter) => {
      counter.innerText = wishlistItemLength;
    });
  }

  class WishlistProduct extends HTMLElement {
    constructor() {
      super();
      this.boundOnAddWishlist = this.onAddWishlist.bind(this);
    }

    connectedCallback() {
      if (this.wishlistInitialized) return;
      this.wishlistInitialized = true;
      this.addEventListener("click", this.boundOnAddWishlist);
      this.onAddActiveClass();
      updateWishlistCounter();
    }

    onAddActiveClass() {
      const wishlistAddedButton = this.querySelector("button");
      if (!wishlistAddedButton) return;

      const productHandle = wishlistAddedButton.dataset.productHandle;
      if (!productHandle) {
        console.error(
          "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
        );
        return;
      }

      wishlistAddedButton.classList.toggle(
        activeClass,
        getWishlist().includes(productHandle)
      );
    }

    onAddWishlist(event) {
      const wishlistItem = this.querySelector("button");
      if (!wishlistItem || !wishlistItem.contains(event.target)) return;

      const productHandle = wishlistItem.dataset.productHandle;
      if (!productHandle) {
        console.error(
          "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
        );
        return;
      }

      updateWishlist(productHandle);
      updateWishlistCounter();

      const grid = document.querySelector("[grid-wishlist]");
      if (grid) {
        this.closest(".product__card")?.remove();
      } else {
        wishlistItem.classList.add("loading", "adding");
        window.setTimeout(() => {
          wishlistItem.classList.remove("loading");
          wishlistItem.classList.toggle(activeClass);
        }, 500);
        window.setTimeout(() => {
          wishlistItem.classList.remove("adding");
        }, 1000);
      }

      if (getWishlist().length <= 0 && grid?.parentElement) {
        grid.parentElement.classList.remove("wishlist_exists");
      }
    }

    getWishlist() {
      return getWishlist();
    }

    setWishlist(array) {
      return setWishlist(array);
    }

    updateWishlist(handle) {
      return updateWishlist(handle);
    }

    wishlistContains(handle) {
      return getWishlist().includes(handle);
    }
  }

  if (!customElements.get("wishlist-item")) {
    customElements.define("wishlist-item", WishlistProduct);
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateWishlistCounter();
    const grid = document.querySelector("[grid-wishlist]");
    if (grid) setupGrid(grid);
  });

  function setupGrid(grid) {
    const wishlist = getWishlist();
    const wishlistPage = document.querySelector(".wishlist-page");

    wishlistPage?.classList.toggle("wishlist_exists", wishlist.length > 0);

    if (!wishlist.length) {
      grid.innerHTML = "";
      return;
    }

    const requests = wishlist.map((handle) => {
      const productTileTemplateUrl =
        "/products/" + encodeURIComponent(handle) + "?view=wishlist";

      return fetch(productTileTemplateUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Wishlist product request failed: ${response.status}`);
          }
          return response.text();
        })
        .catch((error) => {
          console.error("[Wishlist]", error);
          return "";
        });
    });

    Promise.all(requests).then((responses) => {
      grid.innerHTML = responses.filter(Boolean).join("");
    });
  }
})();
